var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import "./BlockMoviesScreenStyles.css";
import { Header } from "../../components/Header";
import { useRouter } from "../../context/Router";
import { getBlockMovies } from "../../services/movie.service";
import { MovieRowView } from "../../components/views/movie/MovieRowView";
import { chunkArray, onMoviePress } from "../../utils/Helpers";
import { useTranslation } from "react-i18next";
import { focusManager } from "../../utils/Focus";
import { ScrollToTopButton } from "../../components/views/buttons/ScrollToTopButton";
import { FooterView } from "../../components/views/footer/FooterView";
import { useTVScroll, isWithinPosterWindow } from "../../hooks/useTVScroll";
import { SkeletonContentLayout } from "../../components/views/SkeletonContentLayout";
import { useModalContext } from "../../context/ModalContext";
export var BlockMoviesScreen = function () {
    var _a = useRouter(), params = _a.params, navigate = _a.navigate, goBack = _a.goBack;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var verticalRef = useRef(null);
    var _c = useState([]), movies = _c[0], setMovies = _c[1];
    var _d = useState(""), blockTitle = _d[0], setBlockTitle = _d[1];
    var _e = useState(true), hasMore = _e[0], setHasMore = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(6), loadedRowsCount = _g[0], setLoadedRowsCount = _g[1];
    var showModal = useModalContext().showModal;
    var rows = useMemo(function () { return chunkArray(movies, 6); }, [movies]);
    useEffect(function () {
        if (focusManager.getCurrentGroup() === "main-navbar")
            return;
        focusManager.manualFocus("main-navbar", 0);
    }, []);
    var handleMoviePress = useCallback(function (movie) {
        var result = onMoviePress(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    var handleBack = useCallback(function () {
        goBack();
        return true;
    }, [goBack]);
    var requestId = useRef(0);
    var fetchMovies = useCallback(function (offset, force) {
        if (offset === void 0) { offset = 0; }
        if (force === void 0) { force = false; }
        if ((!force && (isLoading || !hasMore)) || !params.slug)
            return;
        setIsLoading(true);
        var limit = 18;
        var id = ++requestId.current;
        getBlockMovies(params.slug, {
            lang: i18n.language,
            limit: limit,
            offset: offset,
        })
            .then(function (res) {
            var _a;
            if (id !== requestId.current)
                return;
            var newItems = res.items || [];
            if ((_a = res.block) === null || _a === void 0 ? void 0 : _a.title) {
                setBlockTitle(res.block.title);
            }
            setMovies(function (prev) {
                return offset === 0 ? newItems : __spreadArrays(prev, newItems);
            });
            setHasMore(offset + newItems.length < res.count);
            setIsLoading(false);
        })
            .catch(function (err) {
            if (id !== requestId.current)
                return;
            console.error(err);
            setIsLoading(false);
        });
    }, [params.slug, i18n.language, isLoading, hasMore]);
    useEffect(function () {
        setMovies([]);
        setBlockTitle("");
        setHasMore(true);
        setLoadedRowsCount(6);
        setIsLoading(false);
        fetchMovies(0, true);
    }, [params.slug, i18n.language]);
    useEffect(function () {
        rows.slice(0, loadedRowsCount).forEach(function (_, index) {
            focusManager.registerGroup({
                name: "row-" + index,
                position: index + 100,
                itemHeight: 530,
                verticalContainer: verticalRef.current,
            });
        });
    }, [rows, loadedRowsCount]);
    var onEndReached = useCallback(function () {
        if (loadedRowsCount < rows.length) {
            setLoadedRowsCount(function (prev) { return prev + 3; });
        }
        else {
            fetchMovies(movies.length);
        }
    }, [loadedRowsCount, rows.length, movies.length, fetchMovies]);
    var _h = useTVScroll({ onEndReached: onEndReached }), scrollToTopVisible = _h.scrollToTopVisible, focusedGroup = _h.focusedGroup;
    var focusedRowIndex = useMemo(function () {
        if (focusedGroup && focusedGroup.indexOf("row-") === 0) {
            var parsed = parseInt(focusedGroup.slice(4), 10);
            if (!Number.isNaN(parsed))
                return parsed;
        }
        return 0;
    }, [focusedGroup]);
    var renderedRows = useMemo(function () {
        return rows
            .slice(0, loadedRowsCount)
            .map(function (row, index) { return (React.createElement(MovieRowView, { key: index, index: index, hasHorizontalScroll: false, movies: row, active: isWithinPosterWindow(index, focusedRowIndex), onMoviePress: handleMoviePress, onKeyBack: handleBack })); });
    }, [rows, loadedRowsCount, handleMoviePress, handleBack, focusedRowIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement("div", { ref: verticalRef, className: "screen-container" },
            React.createElement("div", { className: "see-more-screen" }, isLoading && movies.length === 0 ? (React.createElement(SkeletonContentLayout, { showTitle: true, isBlockMoviesScreen: true, skeletonCount: 6 })) : (React.createElement(React.Fragment, null,
                !!blockTitle && React.createElement("h2", null, blockTitle),
                React.createElement("div", { key: params.slug },
                    renderedRows,
                    !hasMore && !isLoading && movies.length > 0 && React.createElement(FooterView, null)))))),
        scrollToTopVisible && React.createElement(ScrollToTopButton, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/BlockMoviesScreen/BlockMoviesScreen.tsx
// module id = 200
// module chunks = 1